import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Iri } from '../../../core/dto/iri';
import { MarkerColor } from '../../../core/dto/marker-color-enum';
import { TypeDto } from '../../../core/dto/type';
import { TaxonomiesService } from '../../../core/taxonomies/taxonomies.service';

const DEFAULT_COLOR = '#1b7faf';

@Pipe({
    name: 'infrastructureMarkerColor',
    pure: true,
})
export class InfrastructureMarkerColorPipe implements PipeTransform {
    constructor(private taxonomiesService: TaxonomiesService) {}

    transform(value: Iri[]): Observable<string> {
        if (!value || !Array.isArray(value) || value.length === 0) return of(DEFAULT_COLOR);
        return this.taxonomiesService.resolveMany<TypeDto>(value).pipe(
            map((types) => {
                if (!types || !types.length) return DEFAULT_COLOR;
                return String(MarkerColor[types[0].marker || 1]).toLowerCase();
            })
        );
    }
}
